import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-16 border-t border-slate-500/20 bg-[#050f20]">
      <div className="mx-auto grid max-w-[1600px] gap-8 px-5 py-10 md:grid-cols-[1.2fr_2fr] lg:px-8">
        <div>
          <Logo small />
          <p className="mt-4 max-w-sm text-xs leading-relaxed text-slate-400">
            Explore the region. Understand the opportunity. Advance the investment. A demonstration platform by Nsync Dimensions — working name only.
          </p>
        </div>
        <div className="grid gap-6 text-xs text-slate-400 sm:grid-cols-3">
          <div className="space-y-2">
            <div className="vig-label text-[11px]">Journey</div>
            {[["Discover", "/discover"], ["Explore", "/explore"], ["Evaluate", "/evaluate"], ["Validate", "/validate"], ["Engage", "/engage"], ["Mobilise", "/mobilise"]].map(([l, t]) => (
              <Link key={t} to={t} className="block hover:text-white">{l}</Link>
            ))}
          </div>
          <div className="space-y-2">
            <div className="vig-label text-[11px]">Platform</div>
            <Link to="/case" className="block hover:text-white">Development & Investment Case</Link>
            <Link to="/sources" className="block hover:text-white">Sources & Methodology</Link>
            <Link to="/admin" className="block hover:text-white">Roles & Administration</Link>
          </div>
          <p data-testid="footer-disclaimer" className="leading-relaxed">
            Concept visualisations only. No investment solicitation, confirmed funding offer or guaranteed return. Not a mandated regional authority or licensed
            intermediary. Investor identities, financials and documents are synthetic. Basemap © OpenStreetMap contributors © CARTO; boundaries © geoBoundaries (CC BY 4.0).
          </p>
        </div>
      </div>
    </footer>
  );
}
